<template>
  <div>
    <v-row>
      <v-col md="5">
        <app-text-search-field
          @input="select()"
          v-model="searchParams.text"
          @filter="showFilter = !showFilter"
        />
      </v-col>
      <v-col md="6">
        <v-chip-group
          v-model="searchParams.status"
          multiple
          mandatory
          @change="select(1)"
        >
          <v-chip
            v-for="option in statusOptions"
            :key="option.value"
            :value="option.value"
            filter
            outlined
          >
            {{ option.text }}
          </v-chip>
        </v-chip-group>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="preSales.data"
          :items-per-page="-1"
          hide-default-footer
          disable-sort
          @click:row="handleView($event)"
        >
          <template v-slot:[`item.created_at`]="{ item }">
            {{ $format.dateTimeBr(item.created_at) }}
          </template>

          <template v-slot:[`item.total_cash`]="{ item }">
            R${{ $format.decimal(item.total_cash) }}
          </template>

          <template v-slot:[`item.total_forward`]="{ item }">
            R${{ $format.decimal(item.total_forward) }}
          </template>

          <template v-slot:[`item.status`]="{ item }">
            <PreSaleStatusChip :value="item.status" />
          </template>

          <template v-slot:[`item.origin`]="{ item }">
            <PreSaleOriginChip v-if="item.origin" :value="item.origin" />
          </template>

          <template v-slot:[`item.action`]="{ item }">
            <v-menu bottom left class="mr-1">
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" text icon color="primary">
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list dense>
                <v-list-item @click="handleConvert(item.id)">
                  <v-list-item-icon class="mr-2">
                    <v-icon color="success">mdi-cart-arrow-right</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>Converter em Venda</v-list-item-content>
                </v-list-item>

                <v-list-item
                  v-if="canCancel(item.status)"
                  @click="handleCancel(item.id)"
                >
                  <v-list-item-icon class="mr-2">
                    <v-icon color="error">mdi-cancel</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>Cancelar Pré-venda</v-list-item-content>
                </v-list-item>

                <v-list-item
                  v-if="!canCancel(item.status)"
                  @click="handleChangeStatus(item.id, 'ready')"
                >
                  <v-list-item-icon class="mr-2">
                    <v-icon color="primary">mdi-refresh</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>Reabrir Pré-venda</v-list-item-content>
                </v-list-item>

                <v-list-item
                  v-if="canMarkAsConverted(item.status)"
                  @click="handleChangeStatus(item.id, 'converted')"
                >
                  <v-list-item-icon class="mr-2">
                    <v-icon color="primary">mdi-check</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    Marcar como Convertida
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <app-pagination @click="select($event)" :data="preSales" />
      </v-col>
    </v-row>

    <PreSaleViewDialog
      ref="preSaleViewDialog"
      @convert="handleConvert"
      @updated="select()"
    />
  </div>
</template>

<script>
import PreSaleViewDialog from "@/components/sales/sections/PreSaleViewDialog.vue";
import PreSaleStatusChip from "@/components/sales/sections/PreSaleStatusChip.vue";
import PreSaleOriginChip from "@/components/sales/sections/PreSaleOriginChip.vue";

export default {
  components: {
    PreSaleViewDialog,
    PreSaleStatusChip,
    PreSaleOriginChip,
  },

  data() {
    return {
      showFilter: false,

      preSales: {
        data: [],
      },

      searchParams: {
        text: "",
        status: ["draft", "ready"],
        start_date: null,
        end_date: null,
        page: 1,
      },

      headers: [
        { text: "Data", value: "created_at" },
        { text: "Nome", value: "name" },
        { text: "Origem", value: "origin" },
        { text: "Total à Vista", value: "total_cash" },
        { text: "Total a Prazo", value: "total_forward" },
        { text: "Status", value: "status" },
        { text: "", value: "action", align: "right" },
      ],

      statusOptions: [
        { text: "Rascunho", value: "draft" },
        { text: "Pronto", value: "ready" },
        { text: "Convertido", value: "converted" },
        { text: "Cancelado", value: "canceled" },
      ],
    };
  },

  mounted() {
    this.select();
  },

  methods: {
    canCancel(status) {
      return ["draft", "ready", "converted"].includes(status);
    },

    canMarkAsConverted(status) {
      return ["draft", "ready"].includes(status);
    },

    async select(page = 1) {
      this.searchParams.page = page;

      const response = await this.$http.$get(
        "sale/pre-sale",
        this.searchParams,
      );

      this.preSales = response.preSales;
    },

    async handleCancel(pre_sale_id) {
      await this.$http.$delete(`sale/pre-sale/${pre_sale_id}`);

      this.select();
    },

    async handleChangeStatus(pre_sale_id, status) {
      await this.$http.$put(`sale/pre-sale/${pre_sale_id}`, {
        status: status,
      });

      this.select();
    },

    handleView(item) {
      this.$refs.preSaleViewDialog.open(item.id);
    },

    async handleConvert(pre_sale_id) {
      const routeData = this.$router.resolve({
        name: "storeSaleForm",
        query: { pre_sale_id: pre_sale_id },
      });

      window.open(routeData.href, "_blank");
    },
  },
};
</script>
